'use strict';

import template from './resetPasswordVerification.component.html';

export const ResetPasswordVerificationComponent = {
	bindings: {},
	controller: ResetPasswordVerificationComponentCtrl,
	controllerAs: 'vm',
	template: template,
};

ResetPasswordVerificationComponentCtrl.$inject = ['mx.sb.ResetPasswordService', '$timeout'];
export function ResetPasswordVerificationComponentCtrl(resetPasswordService, $timeout) {
	const vm = this;
	const minIntervalBetweenClicks = 30 * 1000;
	const maxResendClicked = 3;

	let latestClickTime = Date.now();
	let resendClicked = 0;
	updateScopeTimeout();

	vm.isResendDisabled = function () {
		return resendClicked >= maxResendClicked || Date.now() - latestClickTime < minIntervalBetweenClicks;
	};

	vm.resendEmail = function () {
		resendClicked++;
		latestClickTime = Date.now();
		updateScopeTimeout();
		resetPasswordService.resendEmail();
	};

	function updateScopeTimeout() {
		$timeout(() => {}, minIntervalBetweenClicks);
	}
}
